import { useState } from 'react';
import {
  Box,
  Button,
  Stack,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';
import { BaseDialog } from '@/components/shared/base-dialog';
import type { ResourceApproval } from '@/data/subsidy/interfaces';
import { RefundQueryParams } from '@/packages/subsidy/pages/refund-request/steps/resource-description/interfaces';
import { ResourceApprovalCard } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/resource-type/components/resource-approval-card';

interface ResourceApprovalsDialogProps {
  resourceApprovals: ResourceApproval[];
  onClose?: () => void;
}

export const ResourceApprovalsDialog = ({
  resourceApprovals,
  onClose,
}: ResourceApprovalsDialogProps) => {
  const navigate = useNavigate();
  const [resourceUuid, setResourceUuid] = useState<string | null>(null);

  const handleOnConfirm = () =>
    navigate(
      `/meus-reembolsos/solicitacao/${resourceUuid}?step=${RefundQueryParams.Invoice}`
    );

  return (
    <BaseDialog
      open
      title="Todos os itens aprovados"
      onClose={onClose}
      actionsComponent={
        <>
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleOnConfirm}
            disabled={!resourceUuid}
          >
            Confirmar
          </Button>
        </>
      }
    >
      <Typography>
        Selecione um item aprovado pela sua empresa para enviar os documentos.
      </Typography>
      <Box maxHeight={400} overflow="auto" mt={2}>
        <ToggleButtonGroup
          exclusive
          onChange={(_, value) => setResourceUuid(value)}
          value={resourceUuid}
        >
          <Stack gap={2} flex={1}>
            {resourceApprovals?.map((approval) => (
              <ResourceApprovalCard
                key={approval.uuid}
                resourceApproval={approval}
              />
            ))}
          </Stack>
        </ToggleButtonGroup>
      </Box>
    </BaseDialog>
  );
};
